import DynamicFormResourceModel from '../../generated/types/model/resource/DynamicFormResourceModel';

export default class DynamicFormResourceViewModel extends DynamicFormResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
